import React from "react";
import { Col, Row } from "react-bootstrap";
import PropTypes from 'prop-types';
import { Button, useMediaQuery } from '@mui/material';
import { SelectInput, TextInput } from "../../../../Helpers/Inputs";
import { InputMaskPhone, InputMaskSSN, InputMaskDate } from "../../../../Helpers/Formatters";
import StatesWithDisabled from '../../../../Helpers/Lists/StatesWithDisabled';

export default function BeneficiaryForm(props) {
  const isDesktopLabel = useMediaQuery('(min-width:576px)');

  const getRelationshipSelectOptions = () => {
    if (props.isJuvenile === true) {
      return (
        [
          { value: "20", label: "Parent" },
          { value: "50", label: "Grandparent" }
        ]
      );
    }

    return (
      [
        { value: "13", label: "Child" },
        { value: "20", label: "Parent" },
        { value: "10", label: "Domestic Partner" },
        { value: "50", label: "Grandparent" },
        { value: "9", label: "Spouse" },
        { value: "18", label: "Sibling" },
        { value: "2", label: "Estate of the Insured" },
      ]
    );
  };

  const onFieldChange = (field, value) => {
    // call onChange with the whole updated form
    props.onChange({ ...props.formState, [field]: value });
  };

  const handleValueChange = (field, value, longFieldName) => {
    onFieldChange(field, value);
    props.trigger(longFieldName);
  };

  return (
    <div className="m-2 p-2">
      <div className="mb-3">
        <TextInput
          name={`beneficiaries[${props.index}].firstName`}
          id={`beneficiaries[${props.index}].firstName`}
          label="First Name"
          defaultValue={props.formState.firstName}
          onChange={(e) => onFieldChange('firstName', e.target.value)}
        />
      </div>

      <div className="mb-3">
        <TextInput
          name={`beneficiaries[${props.index}].middleInitial`}
          id={`beneficiaries[${props.index}].middleInitial`}
          label="Middle Initial"
          defaultValue={props.formState.middleInitial}
          onChange={(e) => onFieldChange('middleInitial', e.target.value)}
        />
      </div>

      <div className="mb-3">
        <TextInput
          name={`beneficiaries[${props.index}].lastName`}
          id={`beneficiaries[${props.index}].lastName`}
          label="Last Name"
          defaultValue={props.formState.lastName}
          onChange={(e) => onFieldChange('lastName', e.target.value)}
        />
      </div>

      <div className="mb-3">
        <TextInput
          name={`beneficiaries[${props.index}].address`}
          id={`beneficiaries[${props.index}].address`}
          label="Address 1"
          defaultValue={props.formState.address}
          onChange={(e) => onFieldChange('address', e.target.value)}
        />
      </div>

      <div className="mb-3">
        <TextInput
          name={`beneficiaries[${props.index}].address2`}
          id={`beneficiaries[${props.index}].address2`}
          label="Address 2 (Apt/Suite/Etc)"
          defaultValue={props.formState.address2}
          onChange={(e) => onFieldChange('address2', e.target.value)}
        />
      </div>

      <div className="mb-3">
        <TextInput
          name={`beneficiaries[${props.index}].city`}
          id={`beneficiaries[${props.index}].city`}
          label="City"
          defaultValue={props.formState.city}
          onChange={(e) => onFieldChange('city', e.target.value)}
        />
      </div>

      <Row>
        <Col>
          <div className="mb-3">
            <SelectInput
              name={`beneficiaries[${props.index}].state`}
              id={`beneficiaries[${props.index}].state`}
              defaultValue={props.formState.state}
              onChange={e => handleValueChange('state', e.target.value, `beneficiaries[${props.index}].state`)}
              label="State"
              selectOptions={StatesWithDisabled(props.unavailableStates)}
            />
          </div>
        </Col>

        <Col>
          <div className="mb-3">
            <TextInput
              name={`beneficiaries[${props.index}].zip`}
              id={`beneficiaries[${props.index}].zip`}
              label="Zip"
              defaultValue={props.formState.zip}
              onChange={(e) => onFieldChange('zip', e.target.value)}
            />
          </div>
        </Col>
      </Row>

      <div className="mb-3">
        <TextInput
          name={`beneficiaries[${props.index}].phone`}
          id={`beneficiaries[${props.index}].phone`}
          label="Phone Number"
          defaultValue={props.formState.phone}
          onChange={(e) => onFieldChange('phone', e.target.value)}
          InputProps={{
            inputComponent: InputMaskPhone,
          }}
        />
      </div>

      <div className="mb-3">
        <TextInput
          name={`beneficiaries[${props.index}].email`}
          id={`beneficiaries[${props.index}].email`}
          label="Email"
          defaultValue={props.formState.email}
          onChange={(e) => onFieldChange('email', e.target.value)}
        />
      </div>

      <div className="mb-3">
        <TextInput
          name={`beneficiaries[${props.index}].birthdate`}
          id={`beneficiaries[${props.index}].birthdate`}
          label="Date of Birth"
          defaultValue={props.formState.birthdate}
          onChange={(e) => onFieldChange('birthdate', e.target.value)}
          InputProps={{
            inputComponent: InputMaskDate,
          }}
        />
      </div>

      <div className="mb-3">
        <TextInput
          name={`beneficiaries[${props.index}].ssn`}
          id={`beneficiaries[${props.index}].ssn`}
          label={`${isDesktopLabel ? "Social Security Number (Optional)" : "SSN (Optional)"}`}
          defaultValue={props.formState.ssn}
          onChange={(e) => onFieldChange('ssn', e.target.value)}
          InputProps={{
            inputComponent: InputMaskSSN,
          }}
        />
      </div>

      <div className="mb-3">
        <SelectInput
          name={`beneficiaries[${props.index}].beneficiaryType`}
          id={`beneficiaries[${props.index}].beneficiaryType`}
          defaultValue={props.formState.beneficiaryType}
          onChange={e => handleValueChange('beneficiaryType', e.target.value, `beneficiaries[${props.index}].beneficiaryType`)}
          label="Beneficiary Class"
          selectOptions={[{ value: "Primary", label: "Primary" }, { value: "Contingent", label: "Contingent" }]}
        />
      </div>

      <div className="mb-3">
        <SelectInput
          name={`beneficiaries[${props.index}].relationship`}
          id={`beneficiaries[${props.index}].relationship`}
          defaultValue={props.formState.relationship}
          onChange={e => handleValueChange('relationship', e.target.value, `beneficiaries[${props.index}].relationship`)}
          label="Relationship"
          selectOptions={getRelationshipSelectOptions()}
        />
      </div>

      <div className="mb-3">
        <TextInput
          name={`beneficiaries[${props.index}].percentage`}
          id={`beneficiaries[${props.index}].percentage`}
          label="Percentage"
          defaultValue={props.formState.percentage}
          onChange={(e) => onFieldChange('percentage', e.target.value)}
        />
      </div>

      {props.isRemove && (
        <div className="mb-3">
          <Button onClick={props.onRemove} color="inherit">Remove this Beneficiary</Button>
        </div>
      )}
      <hr />
    </div >
  );
}
BeneficiaryForm.propTypes = {
  formState: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  unavailableStates: PropTypes.array,
  isJuvenile: PropTypes.bool,
  trigger: PropTypes.func,
  onRemove: PropTypes.func,
  isRemove: PropTypes.bool,
};
